import React from "react";
import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";
import { Info } from "@vedmarket/ui-kit";

import SupportAccordionCard from "../accordion-card";
import {COLORS} from "../../../../../config/constants";

import './support-request-requirements.scss'

const SupportRequestRequirements = () => {

  const { t } = useTranslation();

  return (
    <section className='support-request-requirements'>
      <SupportAccordionCard
        title={t('support__text__speedUp')}
        icon={<Info />}
        iconVariant='success'
      >
        <div className='support-request-requirements__content'>
          <Typography
            variant='body1'
            sx={{color: COLORS.BLACK_DARK, letterSpacing: 0, lineHeight: '28px'}}
          >
            {t('support__text__speedUpIntro')}
          </Typography>
          <Typography
            component='ul'
            variant='body1'
            className='support-request-requirements__list'
            sx={{
              color: COLORS.BLACK_DARK,
              letterSpacing: 0,
              lineHeight: '28px',
              margin: 0,
              paddingLeft: '24px',
            }}
          >
            <li className='support-request-requirements__list-item'>{t('support__text__speedUpActions')}</li>
            <li className='support-request-requirements__list-item'>{t('support__text__speedUpExpected')}</li>
            <li className='support-request-requirements__list-item'>
              {t('support__text__speedUpSeen')}
              .
            </li>
          </Typography>
        </div>
      </SupportAccordionCard>
    </section>
  );
};

export default SupportRequestRequirements;
